import create from "zustand";

const useFogControlStore = create((set) => ({
  sceneLighting: {
    skydomeBrightness: 1,
  },
  carReflections: {
    dayXrIntensity: 0.8,
    nightFlipperIntensity: 1,
  },
  dayFog: {
    enabled: true,
    color: "#fefcf0",
    near: 40,
    far: 400,
  },
  xrFog: {
    enabled: true,
    color: "#fff2d5",
    near: 40,
    far: 400,
  },
  nightStudioFog: {
    enabled: true,
    color: "#000000",
    near: 0,
    far: 400,
  },
  suspensionFog: {
    enabled: true,
    color: "#000000",
    near: 5,
    far: 9,
  },
  bloom: {
    enabled: true,
    luminanceThreshold: 0.42,
    luminanceSmoothing: 0.7,
    intensity: 0.63,
    radius: 0.73,
    mipmapBlur: true,
  },
  ambientLight: {
    enabled: true,
    intensityMultiplier: 1,
    color: "#ffffff",
  },
  tunnelLightmaps: {
    enabled: true,
  },
  xrCarPosition: {
    x: 0,
    z: -0.03,
    y: -0.015,
  },
  at21WheelMaterial: {
    color: "#ffffff",
    metalness: 1,
    roughness: 0.51,
    envMapIntensity: 1,
  },
  setAt21WheelMaterial: (patch) =>
    set((state) => ({
      at21WheelMaterial: {
        ...state.at21WheelMaterial,
        ...patch,
      },
    })),
  setDayFog: (patch) =>
    set((state) => ({
      dayFog: {
        ...state.dayFog,
        ...patch,
      },
    })),
  setXrFog: (patch) =>
    set((state) => ({
      xrFog: {
        ...state.xrFog,
        ...patch,
      },
    })),
  setNightStudioFog: (patch) =>
    set((state) => ({
      nightStudioFog: {
        ...state.nightStudioFog,
        ...patch,
      },
    })),
  setSuspensionFog: (patch) =>
    set((state) => ({
      suspensionFog: {
        ...state.suspensionFog,
        ...patch,
      },
    })),
  setSceneLighting: (patch) =>
    set((state) => ({
      sceneLighting: {
        ...state.sceneLighting,
        ...patch,
      },
    })),
  setCarReflections: (patch) =>
    set((state) => ({
      carReflections: {
        ...state.carReflections,
        ...patch,
      },
    })),
  setBloom: (patch) =>
    set((state) => ({
      bloom: {
        ...state.bloom,
        ...patch,
      },
    })),
  setAmbientLight: (patch) =>
    set((state) => ({
      ambientLight: {
        ...state.ambientLight,
        ...patch,
      },
    })),
  setTunnelLightmaps: (patch) =>
    set((state) => ({
      tunnelLightmaps: {
        ...state.tunnelLightmaps,
        ...patch,
      },
    })),
}));

export default useFogControlStore;
